import { ovmQuery, useAxiosInstance, usePoQuery } from '@gov-nx/api';

interface OvmDataQueryProps {
	maAgendy: boolean;
}

export const useOvmDataQuery = ({ maAgendy }: OvmDataQueryProps) => {
	const { axiosInstance } = useAxiosInstance();
	const queryOvm = usePoQuery({
		queryKey: ['ovm', maAgendy],
		queryFn: () => ovmQuery(axiosInstance, maAgendy),
	});

	const ovmList = queryOvm.data?.seznam ?? [];

	return {
		ovmOptions: ovmList.map((ovm) => ({
			value: ovm.kod ?? '',
			label: ovm.nazev ?? '',
		})),
		error: queryOvm.error,
		isLoading: queryOvm.isLoading,
	};
};
